import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const http = axios.create({ baseURL: BASE ? `${BASE}/api` : "/api", withCredentials: true });

export const imgSrc = (src) => (src?.startsWith("/api/") && BASE ? `${BASE}${src}` : src || "");

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function setScrollLock(locked) {
  if (!window.__lenis) return;
  if (locked) window.__lenis.stop();
  else window.__lenis.start();
}

export function openRequest(service, attachCart = false) {
  window.dispatchEvent(new CustomEvent("nodo:request", { detail: { service, attachCart } }));
  scrollToId("richiesta");
}
